@if (hasAnyRole(['SECRETARIA', 'RADIOLOGO', 'ENCARGADO', 'CONTADOR', 'RRHH'])) {
<div class="col-span-12 lg:col-span-6 xl:col-span-4">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Pacientes Mes </span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    {{ countPatientsMonth }}
                </div>
            </div>
            <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-inbox text-blue-500 text-xl!"></i>
            </div>
        </div>
        <span class="text-primary font-medium">
            {{ countPatientsToday }}
        </span>
        <span class="text-muted-color"> Pacientes Hoy</span>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-4">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Monto a Depositar </span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    {{ countTotalAmountDay | formatogs }}
                </div>
            </div>
            <div class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-building-columns text-orange-500 text-xl!"></i>
            </div>
        </div>
        <span class="text-primary font-medium">
            {{ countOutstandingBalance | formatogs }}
        </span>
        <span class="text-muted-color"> Saldo</span>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-4">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Estudios sin Resultados Cargados</span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    <span class="text-red-600 font-bold text-5xl">{{ countPendingResults }}</span>
                </div>
            </div>
            <div class="flex items-center justify-center bg-red-100 dark:bg-red-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-exclamation-triangle text-red-500 text-xl!"></i>
            </div>
        </div>

    </div>
</div>
}
@if (hasAnyRole(['ROOT', 'ADMIN'])) {
<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Pacientes Mes </span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    {{ countPatientsMonth }}
                </div>
            </div>
            <div class="flex items-center justify-center bg-blue-100 dark:bg-blue-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-inbox text-blue-500 text-xl!"></i>
            </div>
        </div>
        <span class="text-primary font-medium">
            {{ countPatientsToday }}
        </span>
        <span class="text-muted-color"> Pacientes Hoy</span>
        <!-- <span class="text-muted-color">since last visit</span> -->
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Monto a Depositar </span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    {{ countTotalAmountDay | formatogs }}
                </div>
            </div>
            <div class="flex items-center justify-center bg-orange-100 dark:bg-orange-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-building-columns text-orange-500 text-xl!"></i>
            </div>
        </div>
        <span class="text-primary font-medium">
            {{ countOutstandingBalance | formatogs }}
        </span>
        <span class="text-muted-color"> Saldo</span>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4"> Total Gs. </span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    <!-- {{ dashboardDto.totalCapital | formatogs }} --> 75.000.000 Gs
                </div>
            </div>
            <div class="flex items-center justify-center bg-cyan-100 dark:bg-cyan-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-wallet text-cyan-500 text-xl!"></i>
            </div>
        </div>
        <span class="text-primary font-medium">
            <!-- {{ dashboardDto.totalCapitalNew }}% --> 5.000.000 Gs
        </span>
        <span class="text-muted-color"> Nuevo</span>
    </div>
</div>
<div class="col-span-12 lg:col-span-6 xl:col-span-3">
    <div class="card mb-0">
        <div class="flex justify-between mb-4">
            <div>
                <span class="block text-muted-color font-medium mb-4">Ganancia Gs. </span>
                <div class="text-surface-900 dark:text-surface-0 font-medium text-xl">
                    <!-- {{ dashboardDto.totalInterest | formatogs}} --> 5.000.000 Gs
                </div>
            </div>
            <div class="flex items-center justify-center bg-purple-100 dark:bg-purple-400/10 rounded-border"
                style="width: 2.5rem; height: 2.5rem">
                <i class="pi pi-credit-card text-purple-500 text-xl!"></i>
            </div>
        </div>
        <span class="text-primary font-medium">
            <!-- {{ dashboardDto.totalInterestNew }}% --> 1.000.000 Gs
        </span>
        <span class="text-muted-color">Nuevo</span>
    </div>
</div>
}